import { createFileRoute } from '@tanstack/react-router'
import { Users } from 'lucide-react'
import { OrganizationManagement } from '@/components/organization-management'
import { UsageCard } from '@/components/UsageCard'

export const Route = createFileRoute('/dashboard/team')({
  component: OrganizationPage,
})

function OrganizationPage() {
  return (
    <div className="w-full px-4 py-8 md:px-8 md:py-10">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-6">
        <section className="rounded-[2rem] border border-border/70 bg-gradient-to-br from-white via-white to-sky-50/70 p-6 shadow-[0_24px_80px_-40px_rgba(15,23,42,0.3)] dark:from-neutral-950 dark:via-neutral-950 dark:to-sky-950/20 md:p-8">
          <div className="space-y-3">
            <div className="inline-flex items-center gap-2 rounded-full border border-primary/20 bg-white/80 px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-primary dark:bg-neutral-950/60">
              <Users className="h-3.5 w-3.5" />
              Team workspace
            </div>
            <div className="space-y-2">
              <h1 className="text-3xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100">
                Team management
              </h1>
              <p className="max-w-2xl text-sm leading-6 text-neutral-600 dark:text-neutral-300">
                Manage organizations, invitations, and member roles from one
                place.
              </p>
            </div>
          </div>
        </section>

        <div className="w-full xl:max-w-[58%]">
          <UsageCard />
        </div>
        <OrganizationManagement />
      </div>
    </div>
  )
}
